import React from 'react';
import { themed } from '../../ui/theme';

interface Props {
  title: string;
  owner?: string;
  /** Conteúdo alinhado à direita (geralmente um ou mais StatusBadge). */
  right?: React.ReactNode;
}

// Cabeçalho padrão dos painéis de tramitação.
//   minimal: título discreto, tracking menor.
//   saas:    título em destaque, tracking amplo.
const PanelHeader: React.FC<Props> = ({ title, owner, right }) => (
  <div className="flex items-center justify-between gap-3 border-b border-slate-200 px-4 py-3 dark:border-slate-700">
    <div className="flex items-center gap-2">
      <span className={`text-xs uppercase text-slate-700 dark:text-slate-200 ${themed({ minimal: 'font-semibold tracking-wide', saas: 'font-bold tracking-widest' })}`}>{title}</span>
      {owner && (
        <>
          <span className="text-xs text-slate-400 dark:text-slate-500">·</span>
          <span className="text-xs font-medium text-slate-600 dark:text-slate-300">{owner}</span>
        </>
      )}
    </div>
    {right && <div className="flex items-center gap-1.5">{right}</div>}
  </div>
);

export default PanelHeader;
